/**
 * List of query parameters that should be preserved across all navigation
 */
export const PRESERVED_PARAMS = ['upcoming-features'] as const;
